export function checkHasBirdviewPortfolioOverdue(item) {
  return item.overdue > 0
}
